###
Gridspy Dashboard Code (v2)

Copyright (c) 2012 Gridspy Ltd
All Rights Reserved
###


CalendarViewModel = window.gs.CVM  
# Require gs_data
SensorDataManager = window.gs.SDM
if not window.dynamic_hostname?
  window.dynamic_hostname = "/d/"

db_path = "/db/"
if window.db_path?
  db_path = window.db_path

NProgress.configure({ ease: 'ease', speed: 200 , trickle:true});

class Building
  constructor: (json_data)->
    @data_start = ko.observable null
    @data_end = ko.observable null

    @trees = {}
    @trees['main'] = new gs.SensorTree()
    @tree_cursors = ko.observableArray []

    @summary_displays = ko.observable {}
    @consts = ko.observable {}
    @active_display = ko.observable "lobby1"
    @curr_summary = ko.computed gs.common.defer => @summary_displays()?[@active_display()]

    @sensors_loaded = ko.observable false

    @loaded = ko.computed => @sensors_loaded()

    @desired_pos = null # Queue up a tree position.


  get_sensor_list: ->
    building_tag = @tag()
    if @sensors_loaded()
      #console?.log "Already have sensor list for #{building_tag}."
      return # Don't need to load these again.

    gs.show_loading("sensors")
    url = "#{dynamic_hostname}#{building_tag}/sensors.json?v=1682"
    $.ajax
      url: url
      dataType: 'json'
      success: (data, textStatus, jqXHR) =>
        console?.log "Got #{building_tag} sensor list:", textStatus, data

        @data_start new Date(data['data_start'])
        @data_end new Date(data['data_end'])

        cursors = []
        if data['hierarachy']['trees']?
          # new style hierarachy
          for own name, hierarachy of data['hierarachy']['trees']
            @trees[name] = new_tree = new gs.SensorTree()
            new_tree.load(hierarachy)
            cursors.push(new gs.NodeCursor(name, new_tree, new_tree.root()))
          @tree_cursors cursors
        else
          @trees['main'].load(data['hierarachy'])
          @tree_cursors [new gs.NodeCursor('main', @trees['main'], @trees['main'].root())]

        if data['summary']?['pages']
          # Load summary screen config
          displays = @summary_displays()
          displays_added = false
          for own name, details of data['summary']['pages']
            unless displays[name]?
              # Create a new summary view
              displays_added = true
              displays[name] = new gs.SummaryView(details)
            else
              # Update an existing view
              displays[name].load(details)

            if displays_added
              # Update the list of displays
              @summary_displays displays

        if data['consts']?
          new_consts = data['consts']
        else
          new_consts = {}

        unless new_consts['price_kwh']?
          new_consts['price_kwh'] = 0.12 # Default price (in $) per kWh
        unless new_consts['interp_results']?
          new_consts['interp_results'] = true # when sensor values are unknown, do we interpolate (true) or substitute 0 instead (false)?
        @consts new_consts

        @sensors_loaded true
        if @desired_pos?
          @set_tree_pos @desired_pos # A queued position.
          @desired_pos = null

        gs.bindings.check_data_dates()
        gs.done_loading("sensors")

      error: (jqXHR, textStatus, errorThrown) =>
        console?.log "Error #{building_tag} from server for sensor List:", textStatus, errorThrown

        gs.done_loading("sensors")
        gs.bindings.show_message "Dashboard Load Error.", "A Server error has prevented you from viewing #{building_tag}", "error"

  update_json:(json_data)->
      ko.mapping.fromJS json_data, {}, @

  set_tree_pos: (path)->
    if @sensors_loaded()
      curr_path = @tree_cursors()[0].get_path()

      return false unless curr_path != path
      #console?.log "set_tree_pos", path

      return @tree_cursors()[0].select_path path
    else
      #console?.log "set_tree_pos Queued:", path
      @desired_pos = path
      return false

class BuildingsMgr
  constructor: ()->
    @buildings = ko.mapping.fromJS [],
      key: (item)-> 
        ko.utils.unwrapObservable(item['pk'])
      update: (data) ->
        building = data.target
        unless building?
          building = new Building(data.data)

        building.update_json(data.data)

        return building
        #Update and return the building, ready to use.
    #@update_list()
    
    @ours = ko.computed => @with_access('ours')
    @friend = ko.computed => @with_access('friend')
    @open = ko.computed => @with_access('public')
    
    @all = ko.computed => @all_func()

  by_tag: (tag) ->
    for building in @buildings()
      if building['tag']() == tag
        return building
    return null
  
  all_func: ->
    # We could use the ko.computed funcs above, but this is slightly more efficient.
    ours = @with_access('admin')
    friend = @with_access('friend')
    open = @with_access('public')
    
    for own idx, [some_buildings, title] of [[ours, "Your Buildings"], [friend, "Shared buildings"], [open, "Open Buildings"]]
      if some_buildings.length == 0
        continue
      else
        title: title
        buildings: some_buildings   
    
  with_access: (access)->
    for building in @buildings()
      if building['access']() != access
        continue
      else
        building

  apply_building_list: (data)->
    ko.mapping.fromJS data, @buildings
    gs.bindings.buildings_updated()        
    
  update_list: ->
    url = "#{dynamic_hostname}buildings.json"
    #url = "http://test1/buildings.json"
    $.ajax
      url: url
      dataType: 'json' 
      success: (data, textStatus, jqXHR) =>
        #console?.log "Got building list:", textStatus, data
        
        @apply_building_list data
        
      error: (jqXHR, textStatus, errorThrown) => 
        console?.log "Error from server for Building List:", textStatus, errorThrown

#============================ Dashboard View Model ==================================
class DashboardViewModel extends gs.BaseViewModel
  constructor: (building) ->
    super [
      new gs.ModeOption("List Buildings", '', '', ->),
      #new ModeOption("Live Data", 'dash', ->),
      new gs.ModeOption("Historical Data", 'dash', '', ->),
      new gs.ModeOption("Summary Screen", 'dash', '', ->),
      #new gs.ModeOption("Export Data", 'dash', '', ->),
      #new ModeOption("Demo Data", 'dash', '', ->),

      new gs.ModeOption("System Installation", 'install', '', ->),
      #new ModeOption("Radio", 'install', '', ->),
      #new ModeOption("Tree", 'install', '', ->),
      ]

    @view_modes = @view_modes.concat( [
      new gs.ModeOption("Login Form", 'login', 'fa-sign-in', =>
        @clear_messages "login"
        $("#inputUser").focus() ),
    ])
    for mode in @view_modes
      mode.set_root(@)

    @building = ko.observable building # Stores the tag name of the current building

    @desc = ko.observable undefined # Building description.
    @server_msg = ko.observable undefined

    @data_mgr = new SensorDataManager(@building())
    @contexts = new gs.ContextMgr(@)
    @calendar = new CalendarViewModel(@contexts)

    @building_list = new BuildingsMgr()
    @bdgs = @building_list # an alias
    
    @curr_time = ko.observable new Date()


    
    @click_building = (building_details)=>
      @set_building(building_details.tag)
      if building_details.desc
        @desc "#{building_details.name}: #{building_details.desc}"
      else  
        @desc "#{building_details.name}"
    
    window.setInterval => 
      @curr_time new Date()
    , 1000
    
    window.setInterval =>
      @check_stale_data()
    , 6 * 60 * 1000 # Check every 6 minutes.
#    , 1 * 60 * 1000 # Check every minute.

    @curr_building = ko.computed => @building_list.by_tag @building()
    @curr_summary = ko.computed => @curr_building()?.curr_summary()

    @loaded = ko.computed => @curr_building()?.loaded()

    @page_heading = ko.computed =>
      if @curr_mode().type == 'dash'
        date_str = @calendar.selected_day().toString("d MMM yyyy")
        building = @curr_building()?.name()
        return "#{building}, #{date_str}"
      else if @mode() == "List Buildings"
        return "Gridspy Dashboard"
      else if @mode() == "System Installation"
        if @inst?.hub.id()
          return "Install #{@inst.hub.id()}"
        else
          return "Install GridHubs"
      else
        return @mode()

    @page_h1 = ko.computed =>
      if @curr_mode().type == 'dash'
        building = @curr_building()?.name()
        return "#{building}"
      else
        return @page_heading()

    @page_h2 = ko.computed =>
      if @curr_mode().type == 'dash'
        building = @curr_building()
        return building?.desc()
      else
        return null

    @data_range = ko.computed => @data_range_str()
    @inst_refresh_nodes = -> gs.live_data.inst_refresh_nodes()

    @primary_tree = ko.computed gs.common.defer =>
      building = @curr_building()
      return null unless building?

      if building.tree_cursors().length == 0
        console?.log "building.tree_cursors not valid"
        return null

      return building.tree_cursors()[0]

    @tree_pos = ko.computed gs.common.defer =>
      tree = @primary_tree()
      return "0" unless tree?

      return tree.get_path()

    @tree_root = ko.computed =>
      tree = @primary_tree()
      return null unless tree?

      return tree.node()

    @tree_root.subscribe (newValue) => @contexts.set_root_node(newValue)

    @current_trees = ko.computed gs.common.defer =>
      building = @curr_building()
      return [] unless building?

      return building.tree_cursors

    @num_trees = ko.computed =>
      building = @curr_building()
      return 0 unless building?

      return building.tree_cursors().length

    @csv_export_url = ko.computed =>
      "https://gridspy.com/d/#{@building()}/history/#{@contexts.start().toString("dMMMyyyy")}-#{@contexts.end().toString("dMMMyyyy")}at15-tz:NZ.csv"

    @csv_export_options = ko.computed =>
      options = [
        [1, "1 Minute"],
        [5, "5 Minute"],
        [15, "15 Minute"],
        [30, "Half-Hourly"],
        [60, "Hourly"],
        [360, "Quarter-Day"],
        [1440, "Daily"],
      ]
      for [span, name] in options
        {url: "#{dynamic_hostname}#{@building()}/history/#{@contexts.start().toString("dMMMyyyy")}-#{@contexts.end().toString("dMMMyyyy")}at#{span}-tz:NZ.csv", name: name}
  url_for: (values = {}, prefix = null)->
    mode = if values.mode? then values.mode else @curr_mode()
    unless prefix?
      prefix = db_path + '#'

    if mode.name == "Summary Screen"
      fullscreen = if values.fullscreen? then values.fullscreen else @fullscreen()
      fullscreen_str = if fullscreen then "/fs" else ""
      tag = if values.tag? then values.tag else @building()
      return (prefix+tag+"/summary"+fullscreen_str)
    else if mode.type == 'dash'
      date = if values.date? then values.date else @calendar.selected_day()
      date_str = date.toString("dMMMyyyy")
      pos = if values.pos? then values.pos else @tree_pos()
      tag = if values.tag? then values.tag else @building()
      interval = if values.interval? then values.interval else @contexts.interval().tag
      if interval != "" and interval[0] != '/'
        interval = "/" + interval  
        
      mode_str = values.mode_str
      unless mode_str?   
        if mode.name == "Live Data"
          mode_str = "/live"
        else if mode.name == "Demo Data"
          mode_str = "/demo"
        else if mode.name == "Summary Screen"
          mode_str = "/summary"
        if mode.name == "Export Data"
          return (prefix+tag+"/export"+interval+"/"+date_str)
        else
          mode_str = "/hist"

      return (prefix+tag+"/"+pos+interval+"/"+date_str+mode_str)
    else if mode.name == "List Buildings"  
      return(prefix+ 'list')
    else if mode.name == "System Installation"
      hub_id = if values.hub_id? then values.hub_id else @inst.hub.id()  
      if hub_id? and hub_id != "" 
        return("#{prefix}setup/#{hub_id}")
      else
        return("#{prefix}setup/")
    else if mode.name == "Tree"
      tag = if values.tag? then values.tag else @building()
      return (prefix+tag+"/tree")
    else if mode.name == "Login Form"
      return "#{prefix}login"
  
  url_for_sensor: (sensor)->
    @url_for pos:sensor.tree_path

  url_for_node: (tree_node)->
    @url_for pos:tree_node.id

  url_for_interval: (interval) ->
    @url_for interval: interval.tag

  set_tree_pos: (path)->
    @curr_building()?.set_tree_pos(path)

  check_stale_data: ->
    # Force a refresh from server for all data that is more than a few minutes old
    day = new Date().clearTime().add(-1).days()
    time = new Date()
    reloaded_spans = {}
#    time.add(20).minutes() # Try to force some updating
    for own pk, spans of @data_mgr.data[+day]
      continue if parseInt(pk) < 0 # Derived sensor.

      for own freq, data of spans
        continue if data.loading

        last_loaded = data.last_update
        if (new Date(last_loaded)).add(second:freq) < time
          # data is stale, request refresh. When the refresh is done, any watching
          #  graphs will automatically re-paint
          @data_mgr.begin_request(day, freq, [pk])

          reloaded_spans[freq] = 1
        else
          continue

#    for own pk, spans of @data_mgr.data[+day]
#      continue if parseInt(pk) >= 0 # Derived sensor.
#
#      for own freq, data of spans
#        if reloaded_spans[freq]?
#          data.data = [] # Wipe the cached data to force a refresh.
#
    return reloaded_spans

  set_day: (day)->
    @calendar.selected_day day
  
  set_building: (tag)->
    building = @building_list.by_tag tag
    
    if not building?
      @login_first "to view this building (#{tag})"
      return

    if @building() != tag
      console?.log "Changed building to", tag
      @building tag
      
      @data_mgr.set_building tag         
  
      @buildings_updated()
    
    if @curr_mode().type != 'dash' 
      @set_mode "Historical Data"
      
      @clear_messages()
      
  buildings_updated: ->
    tag = @building()
    building = @building_list.by_tag tag
    if building?
      building.get_sensor_list()

  set_mode: (mode) ->
    if super(mode)
      # Mode has changed
      if mode.name == "Live Data" or mode.name == "Demo Data"
        gs.live_data?.connect_building @building()

  data_range_str:  ->
    curr_build = @curr_building() 
    return "" if not curr_build?

    curr_build.data_start()?.toString('d MMM yyyy') + ' to ' + curr_build.data_end()?.toString('d MMM yyyy')
    
  date_has_data: (a_date) ->
    #console?.log "date_has_data", a_date, @curr_building(), @curr_building()?.data_start(), @curr_building()?.data_end()
    curr_build = @curr_building() 
    return false if not curr_build?
    
    data_start = curr_build.data_start()
    data_end = curr_build.data_end()
    
    if data_start? and a_date < data_start
      return false
      
    if data_end? and a_date > data_end
      return false
      
    return true

  check_data_dates: ->
    return if @date_has_data @calendar.selected_day()
    
    curr_build = @curr_building() 
    return if not curr_build?
    
    return if @contexts.is_live()

    data_end = curr_build.data_end()
    
    old_selected = @calendar.selected_day()
    new_selected = new Date(data_end).add(-1).hours()
    if new_selected != old_selected
      @calendar.selected_day new_selected
      gs.bindings.calendar.centre()

  apply_login_data: (data) ->
    if data.buildings?
      @bdgs?.apply_building_list data["buildings"]

#============================ Simrou Site Map ==================================

decode_resolution = (resolution) ->
  if resolution == ""
    # Nothing to do
  else if resolution == "month"
    gs.bindings.contexts.set_time_interval 0
  else if resolution == "week"
    gs.bindings.contexts.set_time_interval 1
  else if resolution == "day"
    gs.bindings.contexts.set_time_interval 2
  else if resolution == "quarter"
    gs.bindings.contexts.set_time_interval 3
  else if resolution == "live"
    gs.bindings.contexts.set_time_interval 4
  #else if resolution == "/hour"
  #  gs.bindings.interval_idx 4

decode_date = (date) ->
  if date != ""
    date_parsed = Date.parseExact(date, "dMMMyyyy")
    if date_parsed?
      if not date_parsed.equals(gs.bindings.contexts.end().clone().clearTime())
        # Only change the date if it is different than the current date
        date_parsed.add(1439).minutes()
        gs.bindings.contexts.end date_parsed



gs.router = new Simrou(
  #@get '#install', ->
  #  console?.log "install"

  #@get '#add', ->
  #  console?.log "add"

  'list':
    get: (event, parameters, method) ->
      console?.log "list", event,parameters,method
      gs.bindings.set_mode "List Buildings"
      gs.bindings.calendar.selected_day new Date()

  'login':
    get: (event, parameters, method) ->
      console?.log "login", event,parameters,method
      if !gs.bindings.auth.logged_in()
        gs.bindings.set_mode "Login Form"
      else
        gs.router.resolve "/list"

  'setup':
    get: (event, parameters, method) ->
      console?.log "setup_simple", event,parameters,method
      if !gs.bindings.auth.logged_in()
        gs.bindings.login_first("before you setup your GridHubs.")
        return

      gs.bindings.set_mode "System Installation"

      if gs.bindings.inst?
        gs.bindings.inst.install_hub null

  'setup/:id':
    get: (event, parameters, method) ->
      console?.log "setup", event,parameters,method
      if !gs.bindings.auth.logged_in()
        gs.bindings.login_first("before you setup your GridHubs.")
        return

      gs.bindings.set_mode "System Installation"
      {id: hub_id} = parameters

      console?.log "Setup_hub", hub_id

      if gs.bindings.inst?
        gs.bindings.inst.install_hub hub_id


  ':building/tree':
    get: (event, parameters, method) ->
      console?.log "Tree setup", event,parameters,method
      [building] = @params['splat']

      gs.bindings.set_building building
      gs.bindings.set_mode "Tree"

      gs.bindings.inst.edit_sensor_tree building

  #@get ':building/', ->
  #  gs.bindings.set_building @params.building

  ':building':
    get:  (event, parameters, method) ->
      console?.log "Basic Building", event,parameters,method
      {building:building} = parameters
      gs.bindings.set_building building
      gs.bindings.set_tree_pos "0"
      gs.bindings.contexts.set_time_interval 1
      gs.bindings.check_data_dates()
      gs.bindings.calendar.centre()
      gs.bindings.set_mode "Historical Data"

  ':building/summary':
    get: (event, parameters, method) ->
      console?.log "summary Screen", event,parameters,method
      gs.bindings.set_building parameters["building"]
      gs.bindings.set_mode "Summary Screen"
      gs.bindings.set_fullscreen false

  ':building/summary/fs':
    get: (event, parameters, method) ->
      console?.log "summary Screen Full Acreen", event,parameters,method
      gs.bindings.set_building parameters["building"]
      gs.bindings.set_mode "Summary Screen"
      gs.bindings.set_fullscreen true

  ':building/export/:resolution/:date':
    get: (event, parameters, method) ->
      console?.log "Export Data", event,parameters,method

      {building:building, resolution:resolution, date:date} = parameters

      gs.bindings.set_building building
      gs.bindings.set_mode "Export Data"
      gs.bindings.set_fullscreen false

      decode_date(date)
      decode_resolution(resolution)

      gs.bindings.check_data_dates()
      gs.bindings.calendar.centre()

#  @get /#([a-z0-9_]+)((?:\/[0-9]+)+)?(\/month|\/week|\/day|\/quarter|\/hour|\/live|)(\/[0-9]{1,2}[A-Za-z]{3}[0-9]{4})?(\/live|\/hist|\/demo|\/summary|)\/?$/, ->
  ':building/*path/:resolution/:date/:mode_str':
    get: (event, parameters, method) ->
      console?.log "complex buildings", event,parameters,method
      {building:building, path:path, resolution:resolution, date:date, mode_str:mode_str} = parameters

      gs.bindings.set_building building
      if path != ""
        gs.bindings.set_tree_pos path
      else
        gs.bindings.set_tree_pos "0"

      decode_date(date)
      decode_resolution(resolution)

      gs.bindings.check_data_dates()
      gs.bindings.calendar.centre()

      if mode_str == 'live'
        gs.bindings.set_mode "Live Data"
      else if mode_str == 'hist'
        gs.bindings.set_mode "Historical Data"
      else if mode_str == 'demo'
        gs.bindings.set_mode "Demo Data"
      else if mode_str == 'summary'
        gs.bindings.set_mode "Summary Screen"

      return undefined

  'post/login':
    post: (event, parameters, method) ->
      console?.log "Login post", event,parameters,method
      return false # Do nothing (handled by Knockout.)

  '':
    get: (event, parameters, method) ->
      console?.log "Blank redirect", event,parameters,method
      gs.router.resolve('/list', 'GET')

)  
  
#============================ Startup code ==================================
  
# Enable Javascript Cross site scripting (in particular for IE)
# see http://stackoverflow.com/questions/5241088/jquery-call-to-webservice-returns-no-transport-error
# specifically http://stackoverflow.com/a/6432602/11440
#jQuery.support.cors = true

window.gs.bindings = new DashboardViewModel(null)

if (gs.installer?)
  gs.bindings.inst = window.gs.installer


unless gs.live_data.connected()
  gs.show_loading("live_conn")

console?.log('%cGridSpy Dash', 'font-size:100px;color:#fff;text-shadow:0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);');

# Setup KO
gs.bindings.auth.get_auth =>
  # This code is run once we've loaded auth info such as the list of buildings you can access.
  gs.router.start('list')
  $('#outer_container').show()
  ko.applyBindings(gs.bindings);
  ko.applyBindings(gs.bindings, document.getElementsByTagName("head")[0]); # This lets us set the title using KO



